/**
 * SN-4709: pull a human message out of a rejected balance mutation. The server
 * throws Laravel-standard field-keyed 422s ({ errors: { field: [msg] } }), which
 * req() normalizes to invalid_fields — surface the first field message, else the
 * generic error text. The server 422 is authoritative for the money surface
 * (hidden trashed / payment-in-flight blockers the client can't see).
 */
export const guardMessage = (error: unknown): string => {
  const fields = (error as { invalid_fields?: Record<string, string> })
    ?.invalid_fields
  if (fields) {
    const first = Object.values(fields)[0]
    if (first) {
      return first
    }
  }
  return (error as Error)?.message || 'The request was rejected.'
}

/**
 * The server's message for ONE field of a rejected balance call, or null. For a
 * form that shows an error under the field it names (API-driven field errors),
 * where `guardMessage` would surface whichever field came first.
 */
export const fieldGuardMessage = (
  error: unknown,
  field: string
): string | null =>
  (error as { invalid_fields?: Record<string, string> } | null)
    ?.invalid_fields?.[field] || null
